import { ThemeTokens } from '../base/tokens'
import { colors } from './tokens/colors'
import { effects } from './tokens/effects'
import { components } from './tokens/components'

export const spaceTheme: ThemeTokens = {
  colors,
  effects,
  components
} 